/**
 * Прячет начало строки, заменяя его символами (например, ...)
 * @param {string} text - Исходный текст
 * @param {number} visibleLength - Количество видимых символов
 * @returns {string} - Преобразованный текст
 */
export default function truncateTextFromStart(text, visibleLength) {
    if (text.length <= visibleLength) return text; // Если текст короткий, возвращаем как есть
    return `...${text.slice(-visibleLength)}`; // Оставляем только последние символы
}